import type { CinemaSetting } from '@/types/cinemaSetting'
import { fetchSetting } from '@/api/setting'
import { defaultRechargeLimit, defaultRechargeLowerLimit } from '@/constants'
import { isMainCinemaForFilmInfo } from '@/types/cinemaSetting'
import { clone } from 'ramda'

export const useCinemaSettingStore = defineStore('cinemaSetting', () => {
  const cinemaSetting = ref<CinemaSetting | null>(null)

  async function updateCinemaSetting() {
    const data = await fetchSetting()
    cinemaSetting.value = clone(data)
  }

  const { cinemaId } = storeToRefs(useProfileStore())
  watch(cinemaId, (id) => {
    if (id === 0) {
      return
    }
    // 影院id变了之后更新影院信息。注意：必须要提前调用过 useCinemaSettingStore() 才会执行，目前在 router 中有调用
    void updateCinemaSetting()
  })
  const cardVendor = computed(() => {
    return cinemaSetting.value?.cardVendor
  })
  const productVendor = computed(() => {
    return cinemaSetting.value?.productVendor
  })
  const rechargeLimit = computed(() => {
    return cinemaSetting.value?.rechargeLimit ?? toFen(defaultRechargeLimit)
  })

  const rechargeLowerLimit = computed(() => {
    return cinemaSetting.value?.rechargeLowerLimit ?? toFen(defaultRechargeLowerLimit)
  })

  const mainCinemaForFilmInfo = computed(() => {
    const c = cinemaSetting.value
    if (c == null) {
      return false
    }
    return isMainCinemaForFilmInfo(c.cinemaId)
  })

  return {
    cinemaSetting,
    updateCinemaSetting,
    rechargeLimit,
    rechargeLowerLimit,
    mainCinemaForFilmInfo,
    cardVendor,
    productVendor,
  }
})
